import { render, staticRenderFns } from "./listapedidos-vendedor.vue?vue&type=template&id=7464baf9"
import script from "./listapedidos-vendedor.vue?vue&type=script&lang=js"
export * from "./listapedidos-vendedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports